import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpInterceptorService } from "./http-interceptor.service";

import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { from, Observable } from "rxjs";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormControl, FormsModule, NgControl, ReactiveFormsModule } from "@angular/forms";
import { Injectable } from "@angular/core";
import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  SocialLoginModule,
  SocialAuthServiceConfig,
} from "angularx-social-login";
// import {
//   RECAPTCHA_SETTINGS,
//   RecaptchaFormsModule,
//   RecaptchaModule,
//   RecaptchaSettings,
//   RecaptchaV3Module,
//   ReCaptchaV3Service,
//   RECAPTCHA_V3_SITE_KEY,
// } from "ng-recaptcha";
import { environment } from "../environments/environment";

export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    let langLocal = localStorage.getItem("lang");
    if (langLocal == undefined) {
      localStorage.setItem("lang", "en");
    } else {
      localStorage.setItem("lang", langLocal);
    }
    return from(import(`../assets/i18n/${localStorage.getItem("lang")}.json`));
  }
}
@Injectable({
  providedIn: "root",
})
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,

    SocialLoginModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useClass: WebpackTranslateLoader,
      },
    }),
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [],
  providers: [
    { provide: NgControl, useValue: new FormControl() },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },

    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              "1035424156886-rsnjuho7qct3ji53anf9kh6df2opcupm.apps.googleusercontent.com"
            ),
          },
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider("475270797474579"),
          },
        ],
        onError: (err) => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
    // {
    //   provide: RECAPTCHA_SETTINGS,
    //   useValue: {
    //     siteKey: environment.recaptcha.siteKey,
    //   } as RecaptchaSettings,
    // },
    // ReCaptchaV3Service,

    // {
    //   provide: RECAPTCHA_V3_SITE_KEY,
    //   useValue: environment.recaptcha.siteKey,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
